import type React from "react"

export type TagVariant = "default" | "primary" | "success" | "error" | "warning"
export type TagSize = "sm" | "md"

export interface TagProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: TagVariant
  size?: TagSize
  children: React.ReactNode
}

export const Tag: React.FC<TagProps> = ({
  variant = "default",
  size = "md",
  children,
  className = "",
  ...props
}) => {
  const variantClass = variant === "default" ? "tag" : `tag tag-${variant}`
  const sizeClass = size === "sm" ? "tag-sm" : ""
  const classNames = [variantClass, sizeClass, className].filter(Boolean).join(" ")

  return (
    <span className={classNames} {...props}>
      {children}
    </span>
  )
}